@if (hasCarousel) {
  <div class="top-section-carousel-container">
    <div class="carousel-wrapper">
      <div class="swiper top-section-carousel" #swiperEl>
        <div class="swiper-wrapper">
        @for (slide of carouselSlides; track slide; let i = $index) {
          <div class="swiper-slide">
            <img
              [src]="imgixService.buildImgixUrl(slide.image.url)"
              [alt]="slide.image.altText || 'Carousel image ' + (i + 1)"
              [width]="slide.image.width"
              [height]="slide.image.height"
              class="w-full h-auto block rounded-lg"
              draggable="false"
              />
            <div class="sr-only" [innerHTML]="slide.text"></div>
          </div>
        }
        </div>
      </div>
      <div class="pagination-container">
        <div class="swiper-pagination" #paginationEl></div>
        <button
          type="button"
          class="text-sm absolute right-0 bg-transparent border-0 text-vis-link font-medium cursor-pointer underline p-0 focus:outline focus:outline-2 focus:outline-vis-link focus:outline-offset-2 focus:rounded-xs z-10"
          (click)="openCurrentSlideText()"
          aria-label="View text version of current image"
          >
          View text version
        </button>
      </div>
    </div>
  </div>
}
